
import type { Option, Options } from './typings'

const basicTimeOptions:Option[] = [
  {
    label: '近三个月',
    value: 3
  },
  {
    label: '近六个月',
    value: 6
  },
  {
    label: '近一年',
    value: 12
  },
  {
    label: '近两年',
    value: 24
  },
  {
    label: '近三年',
    value: 36
  },
  {
    label: '近五年',
    value: 60
  },
  {
    label: '近十年',
    value: 120
  }

]
const basicCountOptions:Option[] = [
  {
    label: '不限',
    value: -1
  },
  {
    label: '前1%',
    value: '0-1'
  },
  {
    label: '前5%',
    value: '0-5'
  },
  {
    label: '前10%',
    value: '0-10'
  },
  {
    label: '前30%',
    value: '0-30'
  },
  {
    label: '自定义',
    value: -2
  }
]

const emptyTime = {
  label: '请选择',
  value: -100
}
const last1Month = {
  label: '近一个月',
  value: 1
}
const sinceThisYear = {
  label: '今年以来',
  value: 998
}
const sinceEstab = {
  label: '成立以来',
  value: 999
}
const sincePosition = {
  label: '任职以来',
  value: 999
}
const ManAgeOpt = [
  {
    label: '不限',
    value: -1
  },
  {
    label: '3年以下',
    value: '0-3'
  },
  {
    label: '3-5年',
    value: '3-5'
  },
  {
    label: '5年以上',
    value: '5-max'
  },
  {
    label: '自定义',
    value: -2
  }
]
const FundDutaion = [
  {
    label: '不限',
    value: -1
  },
  {
    label: '3-6个月',
    value: '90-180'
  },
  {
    label: '6-12个月',
    value: '180-365'
  },
  {
    label: '1-2年',
    value: '365-730'
  },
  {
    label: '2-3年',
    value: '730-1095'
  },
  {
    label: '3-5年',
    value: '1095-1825'
  },
  {
    label: '5年以上',
    value: '1825-max'
  },
  {
    label: '自定义',
    value: -2
  }
]
const ManScaleOpt = [
  {
    label: '不限',
    value: -1
  },
  {
    label: '10亿以下',
    value: '0-10'
  },
  {
    label: '10亿~20亿',
    value: '10-20'
  },
  {
    label: '20亿~50亿',
    value: '20-50'
  },
  {
    label: '50亿~100亿',
    value: '50-100'
  },
  {
    label: '100亿以上',
    value: '100-max'
  },
  {
    label: '自定义',
    value: -2
  }
]
const ProScaleOpt = [
  {
    label: '不限',
    value: -1
  },
  {
    label: '10亿以下',
    value: '0-1000000000'
  },
  {
    label: '10亿~20亿',
    value: '1000000000-2000000000'
  },
  {
    label: '20亿~50亿',
    value: '2000000000-5000000000'
  },
  {
    label: '50亿~100亿',
    value: '5000000000-10000000000'
  },
  {
    label: '100亿以上',
    value: '10000000000-max'
  },
  {
    label: '自定义',
    value: -2
  }
]
const ManNumOpt = [
  {
    label: '不限',
    value: -1
  },
  {
    label: '小于3只',
    value: '0-3'
  },
  {
    label: '3-5只',
    value: '3-5'
  },
  {
    label: '5只以上',
    value: '5-max'
  },
  {
    label: '自定义',
    value: -2
  }
]
const ManProfitTime = [emptyTime, last1Month, ...(basicTimeOptions.slice(0, 5)), sinceThisYear, sincePosition]
ManProfitTime.splice(5, 1)

function concatData(time:Option[], count:Option[]): Options {
  return {
    timeOptions: time,
    countOptions: count
  }
}
export default {
  // 基金成立年限
  FundDutaion,
  // 基金规模
  FundScale: ProScaleOpt,
  // 基金收益排名
  FundProfit: concatData([emptyTime, ...basicTimeOptions, sinceThisYear, sinceEstab], basicCountOptions),
  // 基金夏普排名
  FundSharp: concatData([emptyTime, ...basicTimeOptions], basicCountOptions),
  // 基金最大回撤排名
  FundDrawBack: concatData([emptyTime, ...basicTimeOptions], basicCountOptions),
  // 经理的从业年限
  ManAge: ManAgeOpt,
  // 经理的管理规模
  ManScale: ManScaleOpt,
  // 经理的管理产品数
  ManNum: ManNumOpt,
  // 经理的收益排名
  ManProfit: concatData(ManProfitTime, basicCountOptions),
  // 经理的夏普排名
  ManSharp: concatData([emptyTime, last1Month, ...basicTimeOptions], basicCountOptions),
  // 经理的最大回撤排名
  ManDrawBack: concatData([emptyTime, last1Month, ...basicTimeOptions], basicCountOptions)
}

// ['FundRatio', 'FundConcentration', 'FundProfit', 'FundSharp', 'FundDrawBack', 'ManProfit', 'ManSharp', 'ManDrawBack'
export const initResult = {
  FundType: [1],
  FundDutaion: { label: '成立年限' },
  FundScale: { label: '基金规模', unit: '亿元' },
  FundRatio: { label: '持股比例', unit: '%' },
  FundConcentration: { label: '持股集中度', unit: '%' },
  FundProfit: { label: '基金产品/收益排名', unit: '%' },
  FundSharp: { label: '基金产品/夏普排名', unit: '%' },
  FundDrawBack: { label: '基金产品/最大回撤排名', unit: '%' },
  ManAge: { label: '从业年限' },
  ManScale: { label: '管理规模', unit: '亿元' },
  ManNum: { label: '管理产品数' },
  ManProfit: { label: '基金经理/收益排名', unit: '%' },
  ManSharp: { label: '基金经理/夏普排名', unit: '%' },
  ManDrawBack: { label: '基金经理/最大回撤排名', unit: '%' }
  // ManDrawBack: caoncatData([last1Month, ...basicTimeOptions], basicCountOptions)
}
